function initReviewsSlideshow(root) {
  const slides = Array.from(root.querySelectorAll('[data-review-card]'));
  if (slides.length === 0) return;

  const dotsContainer = root.querySelector('[data-reviews-dots]');
  const dots = slides.map((_, i) => {
    if (!dotsContainer) return null;
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'reviews-slideshow__dot';
    dot.setAttribute('aria-label', `Show review ${i + 1}`);
    dot.addEventListener('click', () => show(i));
    dotsContainer.appendChild(dot);
    return dot;
  });

  let index = 0;

  function show(nextIndex) {
    index = (nextIndex + slides.length) % slides.length;
    slides.forEach((slide, i) => {
      slide.classList.toggle('review-card--visible', i === index);
    });
    dots.forEach((dot, i) => {
      if (dot) dot.classList.toggle('reviews-slideshow__dot--active', i === index);
    });
  }

  const prevButton = root.querySelector('[data-reviews-prev]');
  const nextButton = root.querySelector('[data-reviews-next]');
  if (prevButton) prevButton.addEventListener('click', () => show(index - 1));
  if (nextButton) nextButton.addEventListener('click', () => show(index + 1));

  show(0);
}

document.querySelectorAll('[data-reviews-slideshow]').forEach(initReviewsSlideshow);
